export default "__VITE_ASSET__DbVKr2tY__"